import {RootState} from "../store/store";

export const selectOrderInfo = (state: RootState) => state.info.orderInfo;
export const selectAppInfo = (state: RootState) => state.info.appInfo;